import PrintTemplate from 'react-print'
import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import DisplayDelivery from './DisplayDelivery'
import moment from 'moment'
import {formatPrice,formatQuantity} from '../helpers/helpers'

class PrintLabor extends Component{
    render() {
    	

        return (
            <PrintTemplate>
            	<div className="salesReportWrapper">
            		<div className="row topSaleHeader">
		            	<div className="printLogoArea pull-left">
		            		<img src="../../img/solapologo.jpg" />
		            	</div>

		            	<div className="contentReportSolapo pull-right">
							<h3>SOLAPO ROOFING CORPORATION</h3>
							<div className="row marginLeft20px">
								<div className="col-1 pull-left">
									<p><strong>BACOLOD MAIN OFFICE:</strong></p>
									<p><span>3rd Road Burgos Ext.</span></p>
									<p><span>Brgy. Villamonte</span></p>
									<p><span>Bacolod City</span></p>
									<p><span>(034) 441-3860</span></p>
								</div>
								<div className="col-2 pull-left">
									<p><strong>CUSTOMER HOTLINE:</strong></p>
									<p><span>Smart: (0999) 994-6536</span></p>
									<p><span>Sun: (0932) 857-7356</span></p>
									<p><span>Globe (0917) 321-4945</span></p>
								</div>
								<div className="col-3 pull-left">
									<p><strong>EMAIL:</strong></p>
									<p><span>solaporoofingcenter@yahoo.com</span></p>
								</div>
							</div>
		            	</div>
		            	<div className="clearfix"></div>
	            	</div>
	            	<div className="informationLabor">
	            		<p><strong>To:</strong> {this.props.customer.name}</p>
	            		<p><strong>Contact No.:</strong> {this.props.customer.number}</p>
	            		<p><strong>Location:</strong> {this.props.customer.location}</p>
	            		<p><strong>Date:</strong> {this.props.quotation.quoteDate}</p>
	            		<p><strong>Quotation Number: {this.props.quotation.quoteNumber}</strong></p>
	            	</div>
		            <h4 className="text-center"><strong>Labor Cost of Installation</strong></h4>
		            <table className="table tablePrint laborTable">
		                <thead className="theadSalesReport">
		                    <tr>               
		                        <th className="printHeader">Product Name</th>
		                        <th className="printHeader">Quantity</th>
		                        <th className="printHeader">Price</th>
		                        <th className="printHeader">Discount</th>
		                        <th className="printHeader">Amount</th>		                        
		                    </tr>
		                </thead>
		                <tbody>
		                    {
		                        this.props.data &&
		                            Object.keys(this.props.data).map(function (key){
		                                let list = this.props.data[key]
		                                return (<tr>
		                                			<td>
		                                				<strong>{list.name}</strong>
		                                			</td>
		                                			<td>
		                                				{formatQuantity(list.number)}/{list.unit}
		                                			</td>
		                                			<td>
		                                				{formatPrice(list.price)}/{list.unit}
		                                			</td>
		                                			<td>
		                                				{list.discount}%
		                                			</td>		                                			
		                                			<td>
		                                				<strong>{formatPrice(list.total)}</strong>
		                                			</td>
		                                			
		                                		</tr>)
		                           }.bind(this))
		                    }
		                    <tr>
			                    <td><strong>Corners (false)</strong></td>
			                    <td>{formatQuantity(this.props.corners.cornerQty)}/corner</td>
			                    <td>{formatPrice(this.props.corners.cornerPrice)}/corner</td>
			                    <td>{this.props.corners.cornerDis}%</td>
			                    <td>{formatPrice(this.props.corners.cornerTotal)}</td>
		                    </tr>
		                    <tr>
		                    	<td></td>
		                    	<td></td>
		                    	<td></td>
		                    	<td></td>
		                    	<td></td>
		                    </tr>
		                    <tr>
		                    	<td></td>
		                    	<td></td>
		                    	<td></td>
		                    	<td></td>
		                    	<td></td>
		                    </tr>
		                    <tr>		                    	
		                    	<td></td>
		                    	<td></td>
		                    	<td></td>
		                    	<td className="text-center font14"><strong>Total Labor </strong></td>
		                    	<td className="text-left font14">
		                    		<strong>
			                    		{ 
					                        formatPrice(this.props.quotation.laborCost) 

					                    }
					                </strong>
		                    	</td>
		                    </tr>
		                </tbody>
		            </table>
	            </div>
	            <div className="wrappingScope">
		            <div className="scopeOfWork normalLetterSpacing">
		             <hr/>
						<p>SCOPE OF WORK:</p>
						<ul>
							<li>A) Installation of Roofing Materials.</li>
							<li>B) Installation of Corners.</li>
							<li>C) Installation of Scaffoldings if necessary.</li>
							<li>D) All materials are provided by the client, including scaffoldings.</li>
							<li>E) Cleaning and Clearing of Roof Area.</li>
							<li>F) Nothing follows.</li>
						</ul>
						<p>TERM OF PAYMENT:	50% down payment, balance is progress billing.</p>
						<p>CONDITIONS:</p>
						<small>
						1. The installation covers <strong><u>two (2) years warranty</u></strong> against workmanship from the date of completion.<br/>
						2. When cost of installation are based on “Plans only” (not on actual measurement). The buyer shall responsible for any changes in the quantities of materials and/or labor should there be alternations on plans or changes in the final dimensions. Any materials<br/> and/or labor needed to complete the project shall be subject to change in prices without prior notice.
						3. Final billing is subject to adjust base on labor and or materials delivered except on the lump sum contracts.<br/>
						4. Parties expressly submits themselves to the jurisdiction of the courts of Bacolod City for any legal actions arising out of this<br/> transaction and to pay 25% for attorney’s fee plus cost of suit.<br/>
						5. Interest of 5% per month will be changed on overdue account.
						</small>
						<br/><br/><br/><br/><br/><br/><br/><br/>
		            </div>
					<div className="approvedConforme normalLetterSpacing">
						<div className="row">
							<div className="approvedLabor pull-left">
								<p>Approved by:</p>
								<br/><br/>
								<p className="text-center"><strong><u>JASON SOLINAP</u></strong><br/>Installer Supervisor</p>

							</div>
							<div className="conformeLabor pull-right">
								<p>Conforme:</p>
								<br/><br/>
								<p className="printNameSign text-center">__________________________<br/>Print Name and Sign</p>
							</div>
						</div>
					</div>
				</div>
			</PrintTemplate>
        );
    }
};

export default PrintLabor;


// WEBPACK FOOTER //
// ./src/components/PrintLabor.js